var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51855 10.306C3.13055 9.232 2.93655 8.695 3.01855 8.351C3.10955 7.974 3.37755 7.681 3.71955 7.583C4.03255 7.493 4.51955 7.71 5.49255 8.143C6.35255 8.525 6.78255 8.716 7.18755 8.706C7.63355 8.694 8.06155 8.516 8.40255 8.199C8.71255 7.912 8.91955 7.455 9.33455 6.541L10.2495 4.525C11.0135 2.842 11.3956 2 12.0006 2C12.6056 2 12.9876 2.842 13.7516 4.525L14.6666 6.541C15.0816 7.455 15.2895 7.912 15.5985 8.199C15.9395 8.515 16.3686 8.694 16.8135 8.706C17.2176 8.716 17.6485 8.525 18.5085 8.142C19.4825 7.71 19.9685 7.493 20.2815 7.583C20.6235 7.681 20.8916 7.974 20.9816 8.351C21.0646 8.695 20.8706 9.231 20.4816 10.306L18.8145 14.922C18.1005 16.897 17.7445 17.884 16.9976 18.442C16.2506 19 15.2856 19 13.3566 19H10.6445C8.71455 19 7.75055 19 7.00455 18.442C6.25755 17.884 5.90055 16.897 5.18655 14.922L3.51855 10.306Z",
    stroke: "#4E4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H12.009",
    stroke: "#4E4E4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22H17",
    stroke: "#4E4E4E",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.cf9e132c6c00fb8a99211558830575e8.svg";
export { ForwardRef as ReactComponent };